import { format } from 'date-fns';
import React from 'react';
import { DateRangePicker } from '@panwds/react-ui';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';
import { BaseDateFilter } from './BaseDateFilter.esm.js';

const timeFormat = (time) => {
    return format(new Date(time), "PPp");
};
/**
 * Provides a filter with a custom option that allows selecting a time range.
 *
 * Pass items via context in your filter config to provide extra options in the dropdown.
 * All extra props passed via context will be passed to the DateRangePicker.
 */
const DateRangeFilter = ({ initialDateRangeFromFilter = (filterValue) => {
    if (typeof filterValue === "boolean" ||
        typeof filterValue === "string" ||
        typeof filterValue === "number" ||
        Array.isArray(filterValue))
        return;
    if ((filterValue === null || filterValue === void 0 ? void 0 : filterValue.start) === undefined || filterValue === undefined)
        return;
    const { start, end } = filterValue;
    return {
        start: new Date(`${start}`),
        end: new Date(`${end}`),
    };
}, onCustomApply = (date) => {
    return {
        start: date.start.toISOString(),
        end: date.end.toISOString(),
    };
}, customLabel = (filters) => {
    const startLabel = timeFormat(filters.start);
    const endLabel = timeFormat(filters.end);
    return `${startLabel} - ${endLabel}`;
}, ...rest }) => {
    const { filters } = useFilters();
    const initialDateRange = initialDateRangeFromFilter === null || initialDateRangeFromFilter === void 0 ? void 0 : initialDateRangeFromFilter(filters[rest.name]);
    return (React.createElement(BaseDateFilter, { ...rest, customLabel: customLabel, Picker: React.createElement(DateRangePicker, { initialDateRange: initialDateRange, initialActiveDate: initialDateRange === null || initialDateRange === void 0 ? void 0 : initialDateRange.start, onApply: onCustomApply }) }));
};

export { DateRangeFilter, timeFormat };
//# sourceMappingURL=DateRangeFilter.esm.js.map
